import { TGenderCode, TLanguageCode } from '@/includes/definitions/word.d';

export type TArticleObject = { [K in TLanguageCode]: { [T in TGenderCode]: string } };

export const articles: TArticleObject = {
  de: {
    m: 'Der',
    n: 'Das',
    f: 'Die',
    pl: 'Die',
  },
  en: {
    m: '',
    n: '',
    f: '',
    pl: '',
  },
  fr: {
    m: 'Le',
    f: 'La',
    n: '',
    pl: 'les',
  },
};

export const nounArticle = (
  language: TLanguageCode,
  gender: TGenderCode,
) => articles[language][gender];
